exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".header[data-v-5ef9472c]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.header>[data-v-5ef9472c]{height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ef9472c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/vHeader.vue
// module id = 138
// module chunks = 1